import type { SalesforceActivityResponse } from '../../domain/salesforceActivity';
import { HttpClient } from '../../services/HttpClient';

const SALESFORCE_TASKS_API_URL = '/sales-extension/api/salesforce/tasks';

export const salesforceActivityApi = {
  getTasks: (domain: string) => {
    return HttpClient.post<SalesforceActivityResponse>(SALESFORCE_TASKS_API_URL, { domain });
  },
};
